import * as React from 'react';
import {
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemText,
    OutlinedInput,
    SelectChangeEvent,
} from '@mui/material';

export interface MultiSelectProps {
    disabled?: boolean;
    onChange: (next: string[]) => void;
    label?: string;
    options: string[];
    values: string[];
}

export const MultiSelect = ({
    disabled,
    onChange,
    label,
    options,
    values,
}: MultiSelectProps): JSX.Element => {
    const [selectedValues, setSelectedValues] = React.useState<string[]>(values);

    const handleChange = (event: SelectChangeEvent<typeof selectedValues>): void => {
        const { value } = event.target;
        const valArray = value as string[];

        setSelectedValues(valArray);
        onChange(valArray);
    };

    return (
        <FormControl size="small">
            <InputLabel>{label}</InputLabel>
            <Select
                fullWidth
                multiple
                disabled={disabled}
                input={<OutlinedInput label={label} />}
                renderValue={(selected): string => selected.join(', ')}
                size="small"
                value={selectedValues}
                onChange={handleChange}
            >
                {options.map((opt) => (
                    <MenuItem disabled={disabled} key={opt} value={opt}>
                        <Checkbox checked={selectedValues.includes(opt)} />
                        <ListItemText primary={opt} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
